// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#host[data-v-04590df5]{align-self:center}.close[data-v-04590df5]{float:right;padding:0;position:relative;top:-10px;right:-10px}", ""]);
// Exports
module.exports = exports;
